export default {
  getSnapshots: state => state.snapshots,
  totalItems: state => state.totalItems,
  snapshotById: state => state.snapshotById,
};
